module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C94"
  }, [_c('span', {
    staticClass: "size_80"
  }, [_c('span', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Foreword#page_ix"
    }
  }, [_vm._v("Foreword")]), _vm._v(" by David Crystal")])]), _vm._v(" "), _c('p', {
    staticClass: "C89"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Preface#page_xi"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1__A_New#page_1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1__A_New#page_1"
    }
  }, [_vm._v("A New Era")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__Globa#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__Globa#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Global English")])])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__Globa#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Realities, Geopolitics, Issues")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3__Engli#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3__Engli#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("English and Science")])])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3__Engli#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Current Landscape")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4__Impac#page_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4__Impac#page_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Impacts")])])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4__Impac#page_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Discussion of Limitations and Issues for a Global Language")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5__Past#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5__Past#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Past and Future")])])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5__Past#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Do Former Lingua Francas of Science Tell Us?")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6__Does#page_166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "C91"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6__Does#page_166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Does Science Need a Global Language?")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#page_189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C89"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Index#page_215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 66
// module chunks = 0